const configEndpoint = {
  formula: '/virtualtrading/config/formula',
  cancel: '/virtualtrading/cancel',
};

export default configEndpoint;
